export default __webpack_public_path__ + "static/media/logo-26px-2b2a29.883cb07e.svg";